import { Box } from '@mui/material';
import { ButtonComponent } from '../../components/shared/ButtonComponent/ButtonComponent';
import { useContext, useState } from 'react';
import { deleteAssemblyScenario } from '../../services/ScenarioService';
import { ApplicationContext } from '../../components/ApplicationProvider';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var DeleteModal = function (_a) {
    var scenarioid = _a.scenarioid, handleDeletion = _a.handleDeletion;
    var setShowDialog = useContext(ApplicationContext).setShowDialog;
    var _b = useState(false), deleted = _b[0], setDeleted = _b[1];
    var azureADPCA = useMsal().instance;
    var navigate = useNavigate();
    var deleteData = function () {
        var _azureADPCA$getActive, _azureADPCA$getActive2;
        var userEmail = ((_azureADPCA$getActive = azureADPCA.getActiveAccount()) === null || _azureADPCA$getActive === void 0 ? void 0 : _azureADPCA$getActive.username) || 'test@test.com'; // works for initial Azure B2C before customization
        // For customized Azure B2C, user email needs to be retrieved as follows:
        var tokenClaims;
        var userGUID;
        if ((_azureADPCA$getActive2 = azureADPCA.getActiveAccount()) !== null && _azureADPCA$getActive2 !== void 0 && _azureADPCA$getActive2.idTokenClaims) {
            var _azureADPCA$getActive3, _azureADPCA$getActive4;
            tokenClaims = (_azureADPCA$getActive3 = azureADPCA.getActiveAccount()) === null || _azureADPCA$getActive3 === void 0 ? void 0 : _azureADPCA$getActive3.idTokenClaims;
            if (tokenClaims && tokenClaims.hasOwnProperty('email')) {
                userEmail = tokenClaims['email'];
            } //  if (tokenClaims && tokenClaims.hasOwnProperty('aud')) {
            userGUID = (_azureADPCA$getActive4 = azureADPCA.getActiveAccount()) === null || _azureADPCA$getActive4 === void 0 ? void 0 : _azureADPCA$getActive4.localAccountId; //  }
        }
        var dataToDelete = { AzureB2CUserEmail: userEmail, ScenarioId: parseInt(scenarioid) };
        deleteAssemblyScenario(dataToDelete);
        handleDeletion(true);
        setShowDialog(false);
    };
    return /*#__PURE__*/ _jsxs(Box, { display: "flex", flexDirection: "column", children: [/*#__PURE__*/ _jsx("label", { htmlFor: "SavedItemTitle", className: 'small-para-semibold ml-2', children: "Are you sure you want to Delete Scenario ?" }), /*#__PURE__*/ _jsx("br", {}), /*#__PURE__*/ _jsxs("div", { className: "row m-0", children: [/*#__PURE__*/ _jsx(ButtonComponent, { buttonType: 'secondary', buttonText: 'Delete', buttonCss: { margin: 0 }, click: function () { return deleteData(); } }), "\xA0 \xA0", /*#__PURE__*/ _jsx(ButtonComponent, { buttonType: 'primary', buttonText: 'Cancel', buttonCss: { margin: 0 }, click: function () { return setShowDialog(false); } })] })] });
};
